export enum TRANSLATIONS_HELPER_VALUE {
  TRUE = 'true',
  FALSE = 'false'
}

export enum PaymentMethods {
  CARD = 'CARD',
  CASH = 'CASH',
  CHEQUE = 'CHEQUE',
  DEBIT_CARD = 'DEBIT'
}

export enum BusinessUnit {
  US = 'OBU_001',
  JAPAN = 'OBU_018',
  FRANCE = 'OBU_003',
  AUSTRALIA = 'OBU_007'
}
